import script from "./AccountEmailSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountEmailSettings.vue?vue&type=script&setup=true&lang=js"

import "./AccountEmailSettings.vue?vue&type=style&index=0&id=7962e136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7962e136"]])

export default __exports__